import { HTTP } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

export default {
  actions: {
    async [actions.DO_CREATE_TAG]({ commit }, params) {
      const { data } = await HTTP.post('/tags', params);
      commit(mutations.SET_TAG, data.data.tags[0]);
      return data;
    },
  },
  getters: {
    [getters.GET_TAG]: state => state.tag,
  },
  mutations: {
    [mutations.SET_TAG](state, tag) {
      state.tag = tag;
    },
  },
  state: {
    tag: {},
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/tag.js